<div class="quote-assist-v2-container">
  <!-- Loading Overlay -->
  <app-loading-overlay
    [isLoading]="isLoading"
    [loadingState]="(loadingService.loadingState$ | async) ?? undefined"
    [contactId]="queryParams.contactId">
  </app-loading-overlay>

  <!-- Error Banner -->
  <div class="error-banner" *ngIf="(errorState$ | async)?.hasErrors" style="display: none;">
    <div class="error-content">
      <span class="error-icon">⚠️</span>
      <span class="error-message">
        {{ (errorState$ | async)?.errors?.[0]?.userMessage || 'An error occurred' }}
      </span>
      <button class="error-close" (click)="clearErrors()">×</button>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content" *ngIf="!isLoading">
    <!-- Left Sidebar - Progress Tracker -->
    <div class="sidebar" [class.sidebar-demo-active]="isCostBuilderDemoActive">
      <ng-container *ngIf="isCostBuilderDemoActive; else progressTracker">
        <app-cost-builder-demo
          [steps]="costBuilderDemoSteps"
          [startIndex]="costBuilderDemoStartIndex"
          [rfqName]="quoteData.quoteDetails.rfqName"
          (close)="onCostBuilderDemoClosed()"
          (completed)="onCostBuilderDemoCompleted()"
          (stepChange)="onCostBuilderDemoStepChange($event)">
        </app-cost-builder-demo>
      </ng-container>
      <ng-template #progressTracker>
        <app-progress-tracker
          [progressState]="progressState$ | async"
          [parts]="quoteData.partDetails"
          [currentPartIndex]="currentPartIndex"
          [validationErrors]="validationErrors"
          [rfqName]="quoteData.quoteDetails.rfqName"
          [isDraftEnabled]="isAnyPartCompleted()"
          [isSubmitting]="isLoading"
          [isConfirmQuote]="quoteData.isConfirmQuote || false"
          [isQuoteSubmitted]="quoteData.isQuoteSubmitted || false"
          [integrationType]="getIntegrationType()"
          [quoteDetails]="quoteData.quoteDetails"
          [contactId]="queryParams.contactId"
          [isViewMode]="isViewMode"
          (stepClick)="navigateToStep($event)"
          (partClick)="onPartClick($event)"
          (addNewPart)="onAddNewPart()"
          (deletePart)="onDeletePart($event)"
          (addPartFiles)="onAddPartFiles($event)"
          (partFieldChange)="onPartFieldChange($event)"
          (rfqNameChange)="onRfqNameChange($event)"
          (internalNotesChange)="onInternalNotesChange($event)"
          (stepNavigation)="onStepNavigation($event)"
          (submitQuote)="submitQuote($event)">
        </app-progress-tracker>
      </ng-template>
    </div>

    <!-- Right Panel - Main Content -->
    <div class="content-panel">
      <ng-container *ngIf="!quoteDownloadedOrMailSentSuccess">
             <!-- Step 1: Quote Details -->
       <app-quote-details-form
         *ngIf="(progressState$ | async)?.currentStep === 'details'"
         [quoteDetails]="quoteData.quoteDetails"
         [sourceType]="quoteData.sourceType"
         [config]="stepConfig.details"
         [contactId]="queryParams.contactId"
         [currentRfqName]="quoteData.quoteDetails.rfqName"
         [integrationType]="getIntegrationType()"
         [validationState]="(validationState$ | async)?.details || { isValid: false, errors: {}, warnings: {}, touched: {} }"
         [isViewMode]="isViewMode"
         (stepNavigation)="onStepNavigation($event)"
         (saveSuccess)="onQuoteDetailsSaveSuccess($event)"
         (saveError)="onQuoteDetailsSaveError($event)"
         (triggerRfqNameValidation)="onTriggerRfqNameValidation()">
       </app-quote-details-form>

       <!-- Step 2: Parts Information -->
       <app-parts-information
         *ngIf="(progressState$ | async)?.currentStep === 'parts-information'"
         [parts]="quoteData.partDetails"
         [quoteDetails]="quoteData.quoteDetails"
         [quoteData]="quoteData"
         [config]="stepConfig['parts-information']"
         [validationState]="(validationState$ | async)?.['parts-information'] || { isValid: false, errors: {}, warnings: {}, touched: {} }"
         [integrationType]="getIntegrationType()"
         [isQuoteSubmitted]="quoteData.isQuoteSubmitted || false"
         [isEditMode]="isEditMode"
         [skipToConfiguration]="skipToConfigurationForMFG"
         [contactId]="queryParams.contactId"
         [companyId]="queryParams.companyId"
         [isViewMode]="isViewMode"
         [surveyDone]="queryParams.surveyDone"
         (partsChange)="onPartsInformationChange($event)"
         (stepNavigation)="onStepNavigation($event)"
         (fileUploadRequest)="openFileUploadModal($event)"
         (addNewPart)="onAddNewPartRequested()"
         (currentPartIndexChange)="onCurrentPartIndexChange($event)"
         (draftStateChange)="onDraftStateChange($event)"
         (watchDemo)="onWatchDemoRequested()">
       </app-parts-information>

      <!-- Step 4: Cost Breakdown -->
      <app-cost-breakdown
        *ngIf="(progressState$ | async)?.currentStep === 'costs'"
        [costBreakdown]="quoteData.costBreakdown"
        [parts]="quoteData.partDetails"
        [quoteDetails]="quoteData.quoteDetails"
        [config]="stepConfig.costs"
        [validationState]="(validationState$ | async)?.costs || { isValid: false, errors: {}, warnings: {}, touched: {} }"
        [isQuoteSubmitted]="quoteData.isQuoteSubmitted || false"
        [contactId]="queryParams.contactId"
        (costBreakdownChange)="onCostBreakdownChange($event)"
        (stepNavigation)="onStepNavigation($event)"
        (partEdit)="onPartEdit($event)">
      </app-cost-breakdown>

      <!-- Step Navigation Actions -->
      <div class="step-actions" *ngIf="(progressState$ | async)?.currentStep !== 'costs'" style="display: none;">
        <button 
          class="btn btn-secondary" 
          (click)="previousStep()"
          [disabled]="!(progressState$ | async)?.canGoBack">
          <span class="icon">←</span>
          Back
        </button>
        
        <button 
          class="btn btn-primary" 
          (click)="nextStep()"
          [disabled]="!(progressState$ | async)?.canProceed">
          Continue
          <span class="icon">→</span>
        </button>
      </div>
     
        
      </ng-container>
      <!-- Read-Only Overlay - Appears when quote is submitted (only covers content panel) -->
      <div class="quote-readonly-overlay" *ngIf="this.isViewMode && !quoteDownloadedOrMailSentSuccess"></div>
     
      <div *ngIf="quoteDownloadedOrMailSentSuccess">
       <app-quote-success-message [successData]="{companyName: quoteData.quoteDetails.companyName}"></app-quote-success-message>
      </div>
    </div>
  </div>

  <!-- File Upload Modal -->
  <app-file-upload-modal
    *ngIf="showFileUploadModal"
    [partIndex]="currentFileUploadPartIndex"
    [contactId]="queryParams.contactId"
    (fileUpload)="onFileUpload($event)"
    (close)="closeFileUploadModal()">
  </app-file-upload-modal>
</div> 